import { render, staticRenderFns } from "./PremmtHistory.vue?vue&type=template&id=5dd17f94&scoped=true&"
import script from "./PremmtHistory.vue?vue&type=script&lang=js&"
export * from "./PremmtHistory.vue?vue&type=script&lang=js&"
import style0 from "./PremmtHistory.vue?vue&type=style&index=0&id=5dd17f94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd17f94",
  null
  
)

export default component.exports